import { timeFormat, timeParse } from 'd3-time-format';
import { line, curveMonotoneX } from 'd3-shape';
import { extent, max, min } from 'd3-array';
import { linearAxis, timeAxis } from '../../../factory/axes';

import { authority as authorityColors, authorityLabel as authorityLabelColors } from './utils/colors';

export default function (props) {
  const {
    initialWidth, initialHeight, isMobile, raw,
  } = props;

  const margins = {
    top: 10,
    right: isMobile ? 70 : 120,
    bottom: 35,
    left: 35,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  const parser = timeParse('%Y-%m-%d'); // https://github.com/d3/d3-time-format

  // Get unique authority keys (ice, cbp)
  const keys = [...new Set(raw.map(d => d.authority))];

  // Group data by authority
  const data = keys.map(id => ({
    id,
    values: raw
      .filter(d => d.authority === id)
      .map(d => ({ date: parser(d.date), value: d.bookins })),
  }));

  const maxValue = max(data, d => max(d.values, v => v.value));
  const minValue = min(data, d => min(d.values, v => v.value));

  const xAxisConfig = {
    orientation: 'bottom',
    domain: extent(raw, d => parser(d.date)),
    range: [0, width],
    nice: false,
  };

  const yAxisConfig = {
    orientation: 'left',
    domain: [0, maxValue],
    range: [height, 0],
    nice: false,
  };

  const { axis: xAxis, scale: x } = timeAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  // Use authority-specific colors from CNN style guide
  const color = id => authorityColors[id];
  const labelColor = id => authorityLabelColors[id];

  const path = line()
    .curve(curveMonotoneX)
    .x(d => x(d.date))
    .y(d => y(d.value));

  // Abbreviate months longer than 4 characters (e.g. "Jan."); spell out short ones (May, June, July).

  const fmtMonthFull = timeFormat('%B');
  const fmtMonthAbbrev = timeFormat('%b');
  const fmtYearFull = timeFormat('%Y');
  const fmtMonthYear = (date) => {
    const monthFull = fmtMonthFull(date);
    const month = monthFull.length > 4 ? `${fmtMonthAbbrev(date)}.` : monthFull;
    return `${month} ${fmtYearFull(date)}`;
  };

  return {
    color,
    labelColor,
    data,
    fmtYearAbbrev: timeFormat('%y'),
    fmtYearFull: timeFormat('%Y'),
    fmtMonth: timeFormat('%B'),
    // fmtMonthYear: timeFormat('%b. \u2019%y'),
    fmtMonthYear,
    initialWidth,
    initialHeight,
    margins,
    height,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
  };
}
